import { Icon } from '@iconify/react';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import { useState } from 'react';
import { toast } from 'react-toastify';

import { ModalWrapper, SectionTitle } from 'modules/shared/components';

export default function EmployeeCredentialsModal({ open, onClose, data }) {
  const [copied, setCopied] = useState(false);

  if (!data) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(
        `Employee ID: ${data.employeeId}\nPassword: ${data.password}`,
      );
      setCopied(true);
      toast.success('Credentials copied');
      setTimeout(() => setCopied(false), 3000);
    } catch {
      toast.error('Failed to copy credentials');
    }
  };

  return (
    <ModalWrapper open={open} onClose={onClose}>
      <SectionTitle
        title='Employee Credentials'
        action={
          <IconButton onClick={onClose} size='small'>
            <Icon icon='icon-park-outline:close' />
          </IconButton>
        }
      />

      <div className='column'>
        <div className='grid grid--3-cols'>
          <span className='label'>Employee ID</span>
          <span className='value'>{data.employeeId}</span>
        </div>

        <div className='grid grid--3-cols'>
          <span className='label'>Password</span>
          <span className='value'>{data.password}</span>
          <button
            className='btn text-btn text-btn--small justify-self-end'
            onClick={handleCopy}
            disabled={copied}
          >
            <Icon icon='tabler:copy' width={16} />
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>

        <Stack direction='row' justifyContent='flex-end'></Stack>
      </div>
    </ModalWrapper>
  );
}
